import(/* webpackMode: "eager" */ "/home/spielcrypto/Spielcrypto/spielcrypto/src/app/page.tsx");
